import "./Music.css";

import * as React from "react";
import Lyrics from "./Lyrics";
import RehearsalRoom from "./RehearsalRoom";

type MusicItem = "lyrics" | "rehearsalRoom";

interface IMusicState {
    currentMusicItem: MusicItem;
}

export default class Music extends React.Component<{}, IMusicState> {

    public constructor(props: {}) {

        super({});

        this.state = {
            currentMusicItem: "lyrics"
        };
    }

    public render() {

        return (
            <div className="Music">
                <div className="Music__titleContainer">
                    <div className="Music__spacerItem" />

                    {this.renderRegisterItem("lyrics", "TEX", "TE")}

                    <div className="Music__spacerItem" />

                    {this.renderRegisterItem("rehearsalRoom", "PROBE", "RAUM")}

                    <div className="Music__spacerItem" />
                </div>

                <div className="Music__content">
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    private renderRegisterItem(musicItem: MusicItem, titleFirst: string, titleSecond: string) {

        const handleClick = () => this.setMusicItem(musicItem);

        const className = "Music__titleItem";
        const isActive = this.state.currentMusicItem === musicItem;
        const activeModifier = `${className}--${isActive ? "active" : "inactive"}`;

        return (
            <div className={`${className} ${activeModifier}`} onClick={handleClick}>
                <div className="Music__title">
                    <span>{titleFirst}</span>{titleSecond}
                </div>
            </div>
        );
    }

    private setMusicItem(musicItem: MusicItem) {

        this.setState({ currentMusicItem: musicItem });
    }

    private renderContent() {

        switch (this.state.currentMusicItem) {
            case "rehearsalRoom":
                return <RehearsalRoom />;
            case "lyrics":
            default:
                return <Lyrics />;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Music.tsx